import { useEffect } from 'react';
import { useJuneProvider } from '../../contexts/analytics.context';

const usePageTracking = () => {
    const analytics = useJuneProvider();

    useEffect(() => {
        if (analytics) analytics.page()
    }, [analytics]);

    return;
}

export default usePageTracking;